import { requestBuilder } from '../../http/RequestBuilder';
import type { IBill, PartialBill } from '../types/Bill';

type BillsApiUpdateBillParams = Pick<IBill, 'membershipId' | 'id'>;

const useRemoveBill = requestBuilder.mutation<
    PartialBill,
    null,
    BillsApiUpdateBillParams
>({
    endpoint: ({ membershipId, id }) =>
        `/api/holistic-bills/${membershipId}/bill/${id}/remove`,
    method: 'PATCH',
});

export default useRemoveBill;
